import styled, { css } from 'styled-components';

export const BoxGeralTooprice = styled.div`
  display: flex;

  margin-left: 10px;
  margin-right: 10px;
  margin-top: 20px;
`;

export const InputBoxTootlsPrice = styled.div`
  margin-right: 10px;
  background: #d9d9d9;
  width: 100%;
  height: 40px;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  padding-right: 5px;
  align-items: center;
  margin-bottom: 10px;
`;

export const InputPrice = styled.input`
  margin-left: 3px;
  width: 98%;
  height: 30px;
  border: none;
  outline: none;
  background: #d9d9d9;
  font-size: 18px;
`;

export const SeachInputToolPrice = styled.img`
  margin-right: 10px;
  width: 25px;
  height: 25px;
`;
export const InputBoxTootlsPriceRight = styled.div`
  margin-right: 10px;
  background: #d9d9d9;
  width: 100%;
  height: 40px;
  border-radius: 5px;
  display: flex;
  justify-content: space-evenly;
  padding-right: 5px;
  align-items: center;
`;
export const LeftIMGToolPrice = styled.img`
  width: 25px;
  height: 25px;
`;
export const CabecalhoMaster = styled.div`
  background: #ffffff;
  border-radius: 8px;
`;

export const Cabecalho = styled.div`
  padding: 4px;
  border-radius: 8px;
  background: #efefef;
  font-size: 17px;
  display: flex;
  justify-content: space-between;
  color: #364856;
`;

export const CodigoCabecalho = styled.div`
  width: 30%;
  margin-left: 6px;
  border-right: 1px solid #0000005a;
  font-weight: 600;
`;

export const DescricaoCabecalho = styled.div`
  width: 100%;
  text-align: center;
  margin-left: 6px;
  border-right: 1px solid #0000005a;
  font-weight: 600;
`;

export const EanCabecalho = styled.div`
  width: 100%;
  margin-left: 8px;
  font-weight: 600;
  border-right: 1px solid #0000005a;
  text-align: center;
`;
export const PriceCabecalho = styled.div`
  width: 100%;
  text-align: center;
  margin-right: 15px;
  font-weight: 600;
`;

export const Control = styled.button<{ active?: boolean }>`
  ${({ active = true }) => css`
    padding-block: 0;
    padding-inline: 0;
    border-radius: 10px;
    padding: 6px;
    border: none;
    background: white;
    margin: 0;
    cursor: ${active ? 'pointer' : 'default'};
    &:hover {
      background: ${active ? '#eeeeee' : 'none'};
    }
    &:active {
      background: ${active ? '#d9d9d9' : 'none'};
    }
  `}
`;
